import * as React from 'react';
import ProviderForm from "../../components/provider-form/ProviderForm";
import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";
import {Breadcrumbs} from "@mui/material";
import {t} from "i18next";
import Box from "@mui/material/Box";

interface CreateFirstBudgetProps {
    onSubmit: () => void;
}

function CreateFirstProvider(props: CreateFirstBudgetProps) {
    const {onSubmit} = props;
    return (
        <Box sx={{
            padding: {xs: "4%", sm: "2%", lg: "1%"},
        }}>
            <div>
                <Breadcrumbs aria-label="breadcrumb">
                    <Link underline="hover" color="inherit" href="/">
                        Home
                    </Link>
                    <Typography color="text.primary">{t('Create first budget')}</Typography>
                </Breadcrumbs>
                <h1>Witaj w CRM firmy Soft Robotica!</h1>
                <p>Utwórz profil swojej firmy.</p>
                <ProviderForm onSubmit={onSubmit}/>
            </div>
        </Box>

    );
}

export default CreateFirstProvider;